export default "__VITE_ASSET__4o3FLO91__"